import buildRequestUrl from "lib/requests/requestUtils";
import athenaClient from "lib/axios/clients";

const getAggregatedMapData = (urlParams) => {
  const config = {
    method: "GET",
    url: buildRequestUrl(urlParams, "aggregated_map_data"),
  };

  return athenaClient(config);
};

export default getAggregatedMapData;
